import React from 'react';
import { Checkbox } from '@milanote/roma';

import { HotComputedCellValue, TableChangeSource } from '../../../../common/table/TableTypes';
import type { MNHotInstance } from '../tableHotInstanceTypes';
import { CELL_CHECKBOX_RENDERER_CLASS_NAME } from './cellTypeConstants';

import './CellCheckboxRenderer.scss';

type Props = {
    row: number;
    col: number;
    hotComputedCellValue: HotComputedCellValue;
    hotTableInstance: MNHotInstance;
    isEditable?: boolean;
};

const CellCheckboxRenderer: React.FC<Props> = (props) => {
    const { row, col, hotComputedCellValue, hotTableInstance, isEditable = true } = props;

    const value =
        hotComputedCellValue === true ||
        (hotComputedCellValue !== null && hotComputedCellValue.toString().toLowerCase() === 'true');

    const handleChange = (checked: boolean) => {
        if (!isEditable) return;

        // Since checkbox can be immediately toggled (without the cell being selected first), there is a
        // possibility of the checkbox being clicked while another cell is being edited. This will cause
        // `beforeChange` to be called twice very quickly, causing changes in the edited cell to be reverted.
        //
        // The delay here is to give time for other cells to finish editing before we update the checkbox.
        setTimeout(() => {
            hotTableInstance.setDataAtCell(row, col, checked.toString(), TableChangeSource.CHECKBOX_TOGGLE);
        }, 50);
    };

    return (
        <div className={CELL_CHECKBOX_RENDERER_CLASS_NAME}>
            <Checkbox
                aria-label="Toggle checkbox cell"
                size="sm"
                variant="secondary"
                isSelected={value}
                onChange={handleChange}
            />
        </div>
    );
};

export default CellCheckboxRenderer;
